// Local translations
export const T = {
  en_GB: {
    clickToCopy: "Click to copy",
    global: "Global",
    client: "Client",
    system: "System",
    mcp: "MCP",
    searchClient: "Search client...",
    tool: "Tool",
    selectTool: "Select a tool...",
    arguments: "Arguments",
    run: "Run",
    error: "Error",
    success: "Success",
    tokens: "tokens",
    loadToolsFailed: "Failed to load tools",
    executionFailed: "Tool execution failed",
    done: "Done.",
    context: "Context:",
  },
  nb_NO: {
    clickToCopy: "Klikk for å kopiere",
    global: "Global",
    client: "Klient",
    system: "System",
    mcp: "MCP",
    searchClient: "Søk etter klient...",
    tool: "Verktøy",
    selectTool: "Velg et verktøy...",
    arguments: "Argumenter",
    run: "Kjør",
    error: "Feil",
    success: "Vellykket",
    tokens: "tokens",
    loadToolsFailed: "Kunne ikke laste verktøy",
    executionFailed: "Kjøring av verktøyet mislyktes",
    done: "Ferdig.",
    context: "Kontekst:",
  },
} as const;
